import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PersonAddress, PersonDocument, PersonFiles, PersonInformation, PersonPicture, StatusValidation } from '../models/kyc';
import { ResponseBase } from '../models/response-base';

@Injectable({
  providedIn: 'root'
})
export class KycService {

    private URL = environment.GATEWAY + 'kyc/';

    constructor(private http: HttpClient) { }

    statusList(personGuid: string): Observable<ResponseBase<StatusValidation[]>> {
        let params = new HttpParams();
        params = params.append('personGuid', personGuid);

        return this.http.get<ResponseBase<any>>(`${this.URL}statuslist`, { params });
    }

    uploadAddress(personAddress: PersonAddress): Observable<ResponseBase<boolean>> {
        return this.http.post<ResponseBase<boolean>>(`${this.URL}upload/personAddress`, personAddress);
    }

    uploadPersonPicture(personPicture: PersonPicture): Observable<ResponseBase<boolean>> {
        return this.http.post<ResponseBase<boolean>>(`${this.URL}upload/personPicture`, personPicture);
    }

    uploadPersonDocument(personDocument: PersonDocument): Observable<ResponseBase<boolean>> {
        return this.http.post<ResponseBase<boolean>>(`${this.URL}upload/personDocument`, personDocument);
    }

    uploadFiles(personFiles: PersonFiles): Observable<ResponseBase<boolean>> {
        return this.http.post<ResponseBase<boolean>>(`${this.URL}upload/files`, personFiles);
    }

    validateAssignor(assignorGuid: string, personInformation: PersonInformation): Observable<ResponseBase<boolean>> {
        return this.http.post<ResponseBase<boolean>>(`${this.URL}validate/assignors/${assignorGuid}`, personInformation);
    }
}
